import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'getValueFromList',
  standalone: true,
})
export class GetValueFromListPipe implements PipeTransform {
  transform(value: any, list: any[], valueKey: string, displayKey: string) {
    const foundItem = (list || []).find((item) => item[valueKey] === value);

    return _.get(foundItem, displayKey) || 'N.A.';
  }
}
